(function () {

  const fancyLogin = document.getElementById("upng-fancy-login");
  const fancyAgent = document.getElementById("upng-fancy-agent");
  const upngFancyElements = document.querySelectorAll(".upng-fancy");

  //Fancy login
  document
  .querySelector("#fancy-login-opener")
  .addEventListener("click", (event) => {
    event.preventDefault();
    
    if (fancyLogin.style.display === "none") {
      hideFancyElements();
      fancyLogin.style.display = "block";
    } else {
      hideFancyElements();
    }
  });

  document.getElementById('fancy-login-close-button').addEventListener('click',(event) => {
    fancyLogin.style.display = "none";
  });

  if(fancyAgent){
    document
    .querySelector("#fancy-agent-opener")
    .addEventListener("click", (event) => {
      event.preventDefault();
      if (fancyAgent.style.display === "none") {
        hideFancyElements();
        fancyAgent.style.display = "block";
      } else {
        hideFancyElements();
      }
    });

    document.getElementById('fancy-agent-close-button').addEventListener('click',(event) => {
      fancyAgent.style.display = "none";
    });
  }

  function hideFancyElements(){
    upngFancyElements.forEach(function(elemento) {
      elemento.style.display = "none";
    });
  }
    

})();